const getters = {
  activeTab: state => state.activity.activeTab,
}
export default getters
